import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Plus } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import TaskTable from "@/components/TaskTable";
import TaskFormDialog from "@/components/TaskFormDialog";

// Reusable "Tasks" tab for Asset / Lead / Broker detail pages.
export default function RecordTasksTab({ recordType, recordId, recordName }) {
  const [formOpen, setFormOpen] = useState(false);
  const [editTask, setEditTask] = useState(null);

  const { data: tasks = [] } = useQuery({
    queryKey: ["record-tasks", recordType, recordId],
    queryFn: async () =>
      (await api.get("/tasks", { params: { linked_record_type: recordType, linked_record_id: recordId } })).data,
  });

  const openNew = () => { setEditTask(null); setFormOpen(true); };
  const openEdit = (t) => { setEditTask(t); setFormOpen(true); };

  return (
    <div data-testid="record-tasks-tab">
      <div className="flex justify-end mb-3">
        <Button size="sm" onClick={openNew} data-testid="record-add-task-button">
          <Plus className="h-4 w-4 mr-1.5" /> Add Task
        </Button>
      </div>
      <div className="bg-white border border-slate-200 rounded-md">
        <TaskTable tasks={tasks} onEdit={openEdit} hideLinked emptyText="No tasks for this record yet." />
      </div>
      <TaskFormDialog
        open={formOpen}
        onClose={() => setFormOpen(false)}
        task={editTask}
        prefillLink={editTask ? null : { type: recordType, id: recordId, name: recordName }}
      />
    </div>
  );
}
